import { HubConnectionBuilder } from '@microsoft/signalr'
import { MessagePackHubProtocol } from '@microsoft/signalr-protocol-msgpack'

export const signalrConnectionBuilder = new HubConnectionBuilder().withHubProtocol(
  new MessagePackHubProtocol(),
)
